import React, { Component } from 'react';

import deburr from 'lodash/deburr';
import PropTypes from 'prop-types';

import ContentChecklist from './ContentChecklist';

const maxRange = {
  min: 0,
  max: 100
};

const initialState = {
  items: [],
  selectedItemsFiltered: [],
  ...maxRange
};

export default class QuizProfileContent extends Component {
  static propTypes = {
    field: PropTypes.string,
    fieldData: PropTypes.object,
    items: PropTypes.array,
    onMenuOpen: PropTypes.func,
    setValue: PropTypes.func,
    setClearFunction: PropTypes.func
  };

  state = initialState;

  clearState = () => {
    const { items } = this.state;
    const itemsUpdated = items.map((item) => ({
      ...item,
      checked: false,
      show: true
    }));

    this.setState({
      selectedItemsFiltered: [],
      items: itemsUpdated,
      ...maxRange
    });
  };

  componentDidMount() {
    const { items, fieldData } = this.props;
    const { max, min } = fieldData;
    const { setClearFunction } = this.props;

    setClearFunction && setClearFunction(this.clearState);
    this.setState({ items, max, min });
  }

  componentDidUpdate(prevProps) {
    const { items, fieldData } = this.props;

    if (items.length !== prevProps.items.length) {
      const itemsFiltered = items.map((item) => ({
        ...item,
        show: true
      }));

      this.setState({ items: itemsFiltered });
    }

    if (fieldData.ids.length !== prevProps.fieldData.ids.length) {
      const selectedItemsFiltered = items
        .filter((item) => fieldData.ids.includes(item.id))
        .map((item) => ({ ...item, checked: true }));

      const itemsUpdated = items.map((item) => ({
        ...item,
        checked: fieldData.ids.includes(item.id),
        show: true
      }));

      this.setState({
        min: fieldData.min,
        max: fieldData.max,
        selectedItemsFiltered,
        items: itemsUpdated
      });
    }
  }

  onChange(event) {
    const { setValue, field } = this.props;
    const { items } = this.state;
    const selectedItems = event.target.value;

    const itemsUpdated = items.map((item) => ({
      ...item,
      checked: item.checked || selectedItems.includes(item.id)
    }));
    const selectedItemsFiltered = items
      .filter((item) => selectedItems.includes(item.id) || item.checked)
      .map((item) => ({ ...item, checked: true }));

    this.setState({
      selectedItemsFiltered,
      items: itemsUpdated
    });

    const ids = selectedItemsFiltered.map((item) => item.id);

    const value = {
      ids
    };

    setValue(value, field);
  }

  changeFilter(searchedValue) {
    const { items } = this.state;

    const regexSearchedValue = new RegExp(deburr(searchedValue), 'i');
    const itemsFiltered = items.map((item) => {
      item.show = regexSearchedValue.test(deburr(item.name));

      return item;
    });

    this.setState({ items: itemsFiltered });
  }

  removeItem(itemToRemove) {
    const { selectedItemsFiltered, items } = this.state;

    const index = selectedItemsFiltered.findIndex(
      (item) => item.value === itemToRemove.value
    );

    selectedItemsFiltered.splice(index, 1);

    const itemsUpdated = items.map((item) => {
      if (item.value === itemToRemove.value) {
        item.checked = false;
      }

      return item;
    });

    this.setState({ selectedItemsFiltered, items: itemsUpdated });

    const itemsId = selectedItemsFiltered.map((item) => item.id);
    const event = {
      target: {
        value: itemsId
      }
    };

    this.onChange(event);
  }

  setInputRange(value) {
    const { setValue, field } = this.props;

    this.setState(value);

    setValue(value, field);
  }

  clearAll = () => {
    const { items, setValue, field } = this.props;

    const value = {
      ids: [],
      ...maxRange
    };

    const itemsUpdated = items.map((item) => ({
      ...item,
      checked: false,
      show: true
    }));

    this.setState({ selectedItemsFiltered: [], items: itemsUpdated });

    setValue(value, field);
  };

  render() {
    const { field, onMenuOpen, fieldData } = this.props;
    const { items, max, min, selectedItemsFiltered } = this.state;

    const itemsShowed = items.filter((item) => item.show);

    return (
      <ContentChecklist
        field={field}
        onMenuOpen={onMenuOpen}
        fieldData={fieldData}
        clearAll={this.clearAll.bind(this)}
        items={itemsShowed}
        max={max}
        min={min}
        changeFilter={this.changeFilter.bind(this)}
        setInputRange={this.setInputRange.bind(this)}
        removeItem={this.removeItem.bind(this)}
        onChange={this.onChange.bind(this)}
        selectedItems={selectedItemsFiltered}
        placeholderSelect="users_manager.deep_search.content.quiz_profile_placeholder"
        placeholderSearchInput="users_manager.deep_search.content.quiz_score_search_placeholder"
        showRange={true}
      />
    );
  }
}
